import { combineReducers } from 'redux';
import { takeEvery, call, put } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import { LOCATION_CHANGE } from 'react-router-redux';
import get from 'lodash.get';
import { showSnackbarAction } from './snackbar';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';

export const PREPARE_REPORT = 'report/PREPARE_REPORT';
export const DOWNLOAD_DONE = 'report/DOWNLOAD_DONE';
export const GENERATE_OPT_IN_REPORT = 'report/GENERATE_OPT_IN_REPORT';

export const file = (state = null, action) => {
    switch (action.type) {
        case actionKey.success(PREPARE_REPORT):
            return action.payload.file;
        case DOWNLOAD_DONE:
        case PREPARE_REPORT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    file,
});

export const prepareReportAction = ({ body, resolve, reject }) => ({
    type: PREPARE_REPORT,
    body,
    resolve,
    reject,
});

export const downloadDoneAction = () => ({
    type: DOWNLOAD_DONE,
});

export const generateOptInReportAction = ({ resolve, reject }) => ({
    type: GENERATE_OPT_IN_REPORT,
    resolve,
    reject,
});

/**
 * SAGA LISTENRS
 */

export function* prepareReportListener() {
    yield takeEvery(PREPARE_REPORT, prepareReport);
}

export function* rootSaga() {
    yield [
        prepareReportListener(),
        takeEvery(GENERATE_OPT_IN_REPORT, generateOptInReport),
    ];
}

/**
 * REDUX SAGAS
 */
export function* prepareReport({ type, body, resolve, reject }) {
    let positionId;
    if (Number(body.positionId) === -1) {
        positionId = null;
    } else if (Number(body.positionId) !== -2) {
        positionId = body.positionId;
    }
    const allTime = get(body, 'alltime');
    const positionType = get(body, 'positionType');
    const from = get(body, 'date.from');
    const to = get(body, 'date.to');
    const allTimeApp = get(body, 'alltimeapp');
    const fromApp = get(body, 'dateApp.from');
    const toApp = get(body, 'dateApp.to');
    const result = yield call(request, {
        type,
        url: '/api/users/generate-report',
        options: {
            method: 'POST',
            body: {
                ...body,
                dateFrom: !allTime && positionType ? from : null,
                dateTo: !allTime && positionType ? to : null,
                date: undefined,
                dateFromApp: !allTimeApp ? fromApp : null,
                dateToApp: !allTimeApp ? toApp : null,
                positionId,
            },
        },
        cancelActions: [LOCATION_CHANGE],
    });

    if (!result) {
        if (resolve) {
            resolve();
        }
        return;
    }
    if (result.error) {
        if (reject) {
            reject(new SubmissionError({
                _error: result.error === "Something went wrong" ? "Please remove data and/or reduce date range." : result.error,
            }));
        }
    } else if (resolve) {
        resolve(result.payload.file);
    }
}

export function* generateOptInReport({ type, resolve, reject }) {
    const res = yield call(request, {
        type,
        url: '/api/users/college-opt-in-report',
        options: {
            method: 'POST',
        },
        cancelActions: [LOCATION_CHANGE],
    });
    if (res && res.error) {
        yield put(showSnackbarAction({
            message: res.error,
            type: 'failure',
            timeout: 5000,
        }));
        reject(res.error);
    } else {
        resolve(res.payload.file);
    }
}



// WEBPACK FOOTER //
// ./src/client/redux/report.js